import React, {FC} from 'react';
import styled, {css} from 'styled-components';

/*
 * Props.
 */

interface DisabledProps {
  isDisabled: boolean;
}

/*
 * Style.
 */

interface DisabledStyleProps {
  $isDisabled: boolean;
}

const StyledDisabledDiv = styled.div<DisabledStyleProps>`
  ${(p) => maybeAddDisabledStyle(p)};
`;

function maybeAddDisabledStyle(props: DisabledStyleProps) {
  if (!props.$isDisabled) {
    return '';
  }

  return css`
    opacity: 0.5;
    pointer-events: none;
  `;
}

/*
 * Component.
 */

export const Disabled: FC<DisabledProps> = (props) => (
  <StyledDisabledDiv $isDisabled={props.isDisabled}>{props.children}</StyledDisabledDiv>
);
